import { z } from 'zod';

// === start_row / finish_row ===
// A row label is EITHER a fixed-irrigation "bay.bed" sprinkler label ("1.10" is
// bed 10 of bay 1, NOT the decimal 1.1) OR a plain planting / glasshouse row
// number ("7"). See packages/agriculture/src/sprinkler-numbers.ts for the
// ordering and range helpers that understand the format.
//
// These columns are still `numeric` / `double precision` in the database, so a
// bed that is a multiple of ten still collapses on write (1.10 → 1.1) until the
// columns become text. This schema is PHASE 1 of that migration and widens
// VALIDATION only: both shapes are accepted, so the web write boundary
// (phase 2) and then the columns themselves (phase 3) can move to text without
// a lock-step deploy. Verified 2026-08-25: PostgREST casts a numeric string
// into a numeric column, so sending "1.1" is safe against today's schema.
//
// Deliberately NO numeric coercion here — `z.coerce.number()` on a row label is
// precisely the defect this migration exists to remove.

export const RowLabelSchema = z.union([z.string().max(50), z.number()]);

/** Row label that may be absent or explicitly null (most task payloads). */
export const RowLabelOptionalSchema = RowLabelSchema.nullable().optional();

/** Row label that is always present but may be null (general_task rows). */
export const RowLabelNullableSchema = RowLabelSchema.nullable();

export type RowLabel = z.infer<typeof RowLabelSchema>;
